import React from "react";

import { cn } from "@gettactic/helpers";
import { ReactElement } from "react";

interface ButtonGroupProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

export const ButtonGroupComponent: React.FC<ButtonGroupProps> = ({
  children,
  disabled,
  className
}) => {
  const buttons = React.Children.toArray(children).filter(
    React.isValidElement
  ) as ReactElement[];

  return (
    <div
      className={cn(
        "group/btn-group flex h-full flex-row items-center justify-start rounded-lg",
        !disabled &&
          "hover:border-neutral-200 hover:bg-neutral-50/50 hover:shadow-md",
        className
      )}
    >
      {buttons.map((child, index) => {
        const Button = React.cloneElement(
          child as ReactElement,
          child.props as never
        );
        const Divider = index !== buttons.length - 1 && (
          <div className="relative flex items-center">
            <div className="-translate-y-1/2 absolute top-1/2 left-0 h-7 w-[1px] bg-neutral-100 group-hover/btn-group:bg-neutral-200" />
          </div>
        );

        const id = `btn-group-${index}`;
        return (
          <React.Fragment key={id}>
            {Button}
            {Divider}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export const ButtonGroup = React.memo(ButtonGroupComponent);
